import { nToPx, themeVars } from '@tundr/theme';
import { style, styleVariants } from '@vanilla-extract/css';
import { StatusPanelVariant } from './StatusPanel.types';

export const statusPanelClass = style({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  gap: themeVars.space.x4,
  padding: nToPx(themeVars.space.x3, themeVars.space.x4),
  borderRadius: themeVars.radius.md,
  borderWidth: 0,
  borderLeftWidth: 12,
  borderStyle: 'solid',
  fontSize: themeVars.font.size.textMd,
});

export const statusPanelVariants = styleVariants({
  [StatusPanelVariant.INFO]: {
    color:
      themeVars.colors.components.toast[StatusPanelVariant.SUCCESS].text
        .default,
    borderColor:
      themeVars.colors.components.toast[StatusPanelVariant.INFO].border,
    backgroundColor:
      themeVars.colors.components.toast[StatusPanelVariant.INFO].background
        .default,
  },
  [StatusPanelVariant.WARNING]: {
    color:
      themeVars.colors.components.toast[StatusPanelVariant.SUCCESS].text
        .default,
    borderColor:
      themeVars.colors.components.toast[StatusPanelVariant.WARNING].border,
    backgroundColor:
      themeVars.colors.components.toast[StatusPanelVariant.WARNING].background
        .default,
  },
  [StatusPanelVariant.SUCCESS]: {
    color:
      themeVars.colors.components.toast[StatusPanelVariant.SUCCESS].text
        .default,
    borderColor:
      themeVars.colors.components.toast[StatusPanelVariant.SUCCESS].border,
    backgroundColor:
      themeVars.colors.components.toast[StatusPanelVariant.SUCCESS].background
        .default,
  },
  [StatusPanelVariant.ERROR]: {
    color:
      themeVars.colors.components.toast[StatusPanelVariant.SUCCESS].text
        .default,
    borderColor:
      themeVars.colors.components.toast[StatusPanelVariant.ERROR].border,
    backgroundColor:
      themeVars.colors.components.toast[StatusPanelVariant.ERROR].background
        .default,
  },
});

export const statusPanelContentClass = style({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
});

export const statusPanelTitleBaseClass = style({
  marginTop: themeVars.space.x2,
});

export const statusPanelTitleClass = styleVariants({
  [StatusPanelVariant.INFO]: [
    statusPanelTitleBaseClass,
    {
      color: themeVars.colors.components.toast[StatusPanelVariant.INFO].border,
    },
  ],
  [StatusPanelVariant.SUCCESS]: [
    statusPanelTitleBaseClass,
    {
      color:
        themeVars.colors.components.toast[StatusPanelVariant.SUCCESS].border,
    },
  ],
  [StatusPanelVariant.WARNING]: [
    statusPanelTitleBaseClass,
    {
      color:
        themeVars.colors.components.toast[StatusPanelVariant.WARNING].border,
    },
  ],
  [StatusPanelVariant.ERROR]: [
    statusPanelTitleBaseClass,
    {
      color: themeVars.colors.components.toast[StatusPanelVariant.ERROR].border,
    },
  ],
});

export const statusPanelDataListClass = style({
  display: 'flex',
  flexDirection: 'column',
  gap: themeVars.space.x3,
  marginTop: themeVars.space.x3,
});

export const statusPanelDataItemWrapperClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: themeVars.space.x12,
});

export const statusPanelDataItemLabelClass = style({
  fontSize: themeVars.font.size.textMd,
});

export const statusPanelDataItemValueClass = style({
  fontWeight: themeVars.font.weight.bold,
  fontSize: themeVars.font.size.textMd,
});
